<template>
  <div class="row rowcorrect rowEqual" v-if="checkRoles('configuration', 'ContactDataReportList')">
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <b-row>
          <b-col md="4" sm="12">
            <b-form-group>
              <label>{{ $t('views.excmcase.form.contractorUserData') }}</label>
              <base-select-input
                v-model="filters.idContractor"
                :search-callback="userDataSearchCallback"
                :display-values="['fullName', 'firmname1']"
                :query-param="'userdata'"
                :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
              ></base-select-input>
            </b-form-group>
          </b-col>
          <b-col md="4" sm="12">
            <b-form-group>
              <label>{{$t('views.agreements.form.paymentPeriod') + ' ' + $t('global.smFrom')}}:</label>
              <VueCtkDateTimePicker no-header
                                    :label="$t('views.agreements.form.paymentPeriod') + ' ' + $t('global.smFrom')"
                                    v-model.lazy="filters.dateFrom"
                                    v-debounce="delay"
                                    format="YYYY-MM-DD"
                                    :onlyDate="true"
                                    :right="true"
                                    formatted="ll"
              >
              </VueCtkDateTimePicker>
            </b-form-group>
          </b-col>
          <b-col md="4" sm="12">
            <b-form-group>
              <label>{{$t('views.agreements.form.paymentPeriod')  + ' ' + $t('global.smTo')}}:</label>
              <VueCtkDateTimePicker no-header
                                    :label="$t('views.agreements.form.paymentPeriod')  + ' ' + $t('global.smTo')"
                                    v-model.lazy="filters.dateTo"
                                    v-debounce="delay"
                                    format="YYYY-MM-DD"
                                    :onlyDate="true"
                                    :right="true"
                                    formatted="ll"
              >
              </VueCtkDateTimePicker>
            </b-form-group>
          </b-col>
        </b-row>
        <Loader v-if="loading"></Loader>
        <b-card-body v-else>
          <b-table
            striped hover
            :borderless="true"
            :items="items"
            :fields="columns"
          >
            <template v-slot:head(checkbox)="data">
              <b-form-checkbox @change="toggleSelectCurrentPage()" :checked="checkboxSelectAllStatus"  :indeterminate="checkboxSelectIndeterminateStatus"></b-form-checkbox>
            </template>
            <template v-slot:cell(checkbox)="data">
              <b-form-checkbox v-model="selectedContractors" :value="data.item.id"></b-form-checkbox>
            </template>
            <template v-slot:cell(firmname1)="data">
              <router-link v-if="data.item.isCompany === 0" :to="{ name: 'ContractorShow', params: { id: '/core/public/index.php/api/user_datas/' + data.item.id }}">
                {{ data.item.name }} {{data.item.surname}}
              </router-link>
              <router-link v-else :to="{ name: 'FirmShow', params: { id: '/core/public/index.php/api/user_datas/' + data.item.id }}">
                <div v-if="data.item.firmname1">{{ data.item.firmname1 }}<br></div>
                <div v-if="data.item.firmname2 && data.item.firmname2 !== data.item.firmname1">{{ data.item.firmname2 }}<br></div>
                {{ $t('views.firm.form.nip') + ': ' + data.item['nip'] }}
              </router-link>
            </template>
            <template v-slot:cell(applicationData)="data">
              <router-link v-for="(item, index) in data.item.applicationData.subdomains" :key="'application' + index" :to="{ name: 'ApplicationShow', params: { id: '/core/public/index.php/api/applications/' + item.id }}">
                <br v-if="index > 0"><span>{{ item.subdomain }}</span>
              </router-link>
              <p class="m-0">{{$t('views.reports.contactData.list.activeAgreements')}}: {{data.item.applicationData.activeAgreements}}</p>
              <p class="m-0">{{$t('views.reports.contactData.list.activeGroupUserdata')}}: {{data.item.applicationData.activeGroupUserdata}}</p>
            </template>
            <template v-slot:cell(invoiceData)="data">
              <router-link v-for="(item, index) in data.item.invoiceData" :key="'invoice' + index" :to="{ name: 'EXSBInvoiceShow', params: { id: '/core/public/index.php/api/e_x_s_b_invoices/' + item.id }}">
                <br v-if="index > 0"><span>{{ item.number }} - {{$t('views.exsbinvoices.list.issueDate')}} {{$moment(item.issueDate.date).format('YYYY-MM-DD')}}</span>
              </router-link>
            </template>
            <template v-slot:cell(options)="data">
              <b-dropdown
                class="float-left"
                size="sm" variant="link"
                right text="Right align"
                toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item @click="downloadBalancePdf(data.item.id)"><i class="fa fa-file-pdf mr-2"></i>{{$t('buttons.downloadBalancePdf')}}</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <p v-if="counted">{{$t('global.totalItems')}}: {{counted}}</p>
          <div class="d-flex justify-content-between">
            <b-pagination @change="fetchData($event)" v-model="page" :per-page="perPage" :total-rows="counted" class="ml-4"></b-pagination>
            <select :text="$t('global.itemsPerPage')" class="m-md-2" v-model="perPage">
              <option v-for="option in [5, 10, 25, 50, 100]" :key="option" :value="option">
                {{ option }}
              </option>
              <option :value="counted">{{ $t('menu.agreements.listAll') }}</option>
            </select>
          </div>
          <div class="form-group">
            <p>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedContractors.length }}</b></p>
            <button type="button" class="btn btn-sm btn-warning float-left" @click="selectAll()"> {{ $t('buttons.selectAll') }} </button>
            <button type="button" class="btn btn-sm btn-warning float-left" @click="unSelectAll()"> {{ $t('buttons.unSelectAll') }} </button>
            <b-dropdown size="sm" variant="warning" dropright text="Drop-Right" :disabled="selectedContractors.length === 0">
              <template #button-content>
                {{ $t('buttons.collectionOperations') }}
              </template>
              <b-dropdown-item @click="pdfSelectedBalance"><i class="fa fa-file-pdf mr-2"></i>{{$t('buttons.downloadBalancePdfSelected')}}</b-dropdown-item>
              <b-dropdown-item @click="zipSelectedBalance"><i class="fa fa-file-pdf mr-2"></i>{{$t('buttons.downloadBalanceZipSelected')}}</b-dropdown-item>
            </b-dropdown>
            <div class="float-right">
              <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-file-spreadsheet"></i>
              </b-button>
              <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-spinner fa-spin"></i>
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import moment from 'moment'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'invoicesBalance',
  components: { BaseSelectInput, Loader, VueCtkDateTimePicker },
  data () {
    return {
      loading: true,
      items: [],
      counted: 0,
      page: 1,
      perPage: 10,
      delay: 500,
      filters: {
        idContractor: '',
        dateFrom: moment().startOf('year').format('YYYY-MM-DD'),
        dateTo: moment().endOf('year').format('YYYY-MM-DD')
      },
      downloadXlsStatus: 0,
      columns: [
        { key: 'checkbox', label: this.$t('X') },
        { key: 'firmname1', label: this.$t('views.firm.list.firmname1') },
        { key: 'applicationData', label: this.$t('views.reports.contactData.list.applicationData') },
        { key: 'invoicesCount', label: this.$t('views.reports.invoicesBalance.list.invoicesCount') },
        { key: 'invoiceData', label: this.$t('views.reports.invoicesBalance.list.invoiceData') },
        { key: 'totalValueBruttoSum', label: this.$t('views.reports.invoicesBalance.list.sumTotalValueBrutto') },
        { key: 'paidSum', label: this.$t('views.reports.invoicesBalance.list.sumPaid') },
        { key: 'toPaySum', label: this.$t('views.reports.invoicesBalance.list.sumToPay') },
        { key: 'options', label: this.$t('views.excmtag.options') }
      ],
      selectedContractors: []
    }
  },
  computed: {
    checkboxSelectAllStatus () {
      // Sprawdzenie czy wszystkie elementy z items znajdują się w selectedInvoicesToSend. Kolejność nie ma znaczenia
      return this.items.every(item => this.selectedContractors.includes(item.id))
    },
    checkboxSelectIndeterminateStatus () {
      if (this.checkboxSelectAllStatus) {
        return false
      }
      return this.items.some(item => this.selectedContractors.includes(item.id))
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.fetchData()
      }
    },
    perPage () {
      this.fetchData(1)
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'ContactDataReportList')
  },
  created () {
    this.fetchData()
  },
  destroyed () {
  },
  methods: {
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = { xls: 1, dateFrom: this.filters.dateFrom, dateTo: this.filters.dateTo, idContractor: getId(this.filters.idContractor) }
      await new ApiService('reports/balancereport', params).downloadFile('balancereport.xls')
      this.downloadXlsStatus = 0
    },
    async fetchData (page = this.page) {
      this.page = page
      this.loading = true
      let params = { perPage: this.perPage, page: page, dateFrom: this.filters.dateFrom, dateTo: this.filters.dateTo, idContractor: getId(this.filters.idContractor) }
      let response = await new ApiService('reports/balancereport', params).getResults()
      this.items = response.data
      this.counted = response.counted
      this.loading = false
    },
    downloadBalancePdf (id) {
      let params = { selections: [id], dateFrom: this.filters.dateFrom, dateTo: this.filters.dateTo, fileType: 'pdf' }
      new ApiService('reports/balancereportdownload', params).downloadFile('balance.pdf')
    },
    pdfSelectedBalance () {
      let params = {
        selections: this.selectedContractors,
        fileType: 'pdf'
      }
      new ApiService('reports/balancereportdownload', params).downloadFile('FakturyZbiorcze.pdf' + ' ' + this.$moment().format('YYYY-MM-DD'))
    },
    zipSelectedBalance () {
      let params = {
        selections: this.selectedContractors,
        fileType: 'zip'
      }
      new ApiService('reports/balancereportdownload', params).downloadFile(this.$moment().format('YYYY-MM-DD') + '_Salda.zip')
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    selectAll () {
      let selectAll = []
      for (let i in this.items) {
        selectAll.push(this.items[i].id)
      }
      this.selectedContractors = selectAll
    },
    unSelectAll () {
      this.selectedContractors = []
    },
    toggleSelectCurrentPage () {
      if (this.checkboxSelectAllStatus) {
        // Usuń wszystkie id z bieżącej strony
        this.selectedContractors = this.selectedContractors.filter(
          id => !this.items.some(item => item.id === id)
        )
      } else {
        // Dodaj brakujące id z bieżącej strony
        const idsToAdd = this.items
          .filter(item => !this.selectedContractors.includes(item.id))
          .map(item => item.id)
        this.selectedContractors = [...this.selectedContractors, ...idsToAdd]
      }
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  },
  directives: {
    debounce
  }
}
</script>
